import { ItemStatus } from "@/services/collection/item/collectionItemTypes";
import { NaturalNumber_Schema } from "@/utilities";
import { z } from "zod";

export const CollectionItemId_Schema = NaturalNumber_Schema;

export const CollectionItemStatus_Schema = z.enum(ItemStatus);
